import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { ToastProvider } from './components/Toast';
import DropdownKeyboard from './components/DropdownKeyboard';

export default function App() {
  return <ToastProvider><BrowserRouter><DropdownKeyboard /><AppRoutes /></BrowserRouter></ToastProvider>;
}
